import { Button, InputText, FilterList, TEOLoader } from '@teo/components';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Search,
  ChevronDown,
  ChevronUp,
  Tag,
  Check,
} from '@teo/components/icons';
import { PaginationPlusOne } from '@/components/DataTable/PaginationPlusOne';
import { useGet } from '@/query/fetchHooks';

export const OrgLibrary = ({
  authUser,
  setIsOpenLibraryModal,
  isOpenLibraryModal,
  tagsFilter,
  lessonPage,
  setIsOpenAddModal,
  isOpenAddModal,
  onSelectImage,
}) => {
  const { t } = useTranslation();
  const [loadImages, setLoadImages] = useState(true);
  const [filterInput, setFilterInput] = useState('');
  const [debouncedFilter, setDebouncedFilter] = useState('');
  useEffect(() => {
    const t = setTimeout(() => setDebouncedFilter(filterInput), 250);
    return () => clearTimeout(t);
  }, [filterInput]);
  const [filterJoined, setFilterJoined] = useState('');
  const [selected, setSelected] = useState([]);
  const [sort, setSort] = useState([{ id: 'createdAt', desc: true }]);
  const [nmOfImage, setNmOfImage] = useState(0);

  const selectedTags = selected?.map((el) => el.value + ' ');

  useEffect(() => {
    const newFilterJoined =
      selectedTags.join(' ') + (debouncedFilter ? ` ${debouncedFilter}` : '');
    setFilterJoined(newFilterJoined);
  }, [debouncedFilter, selectedTags]);

  return (
    <div className="-mx-6 max-h-[80vh] overflow-hidden pt-5">
      <div className={`${isOpenAddModal && 'hidden'}`}>
        <div className={`relative mb-5 px-6`}>
          <InputText
            value={filterInput}
            onChange={(ev) => {
              setFilterInput(ev.target.value);
              setLoadImages(true);
            }}
            Icon={Search}
            placeholder={t(
              'pages.create_edit_course.library.placeholder_search'
            )}
          />
        </div>
        <div className="mb-5 flex flex-col justify-between gap-4 px-6 lg:flex-row lg:gap-0">
          <div className={`relative flex items-center `}>
            <Tag className="mr-4 w-5 text-grey-07" />
            {tagsFilter && (
              <FilterList
                filters={tagsFilter}
                onSelect={setSelected}
                selected={selected}
              />
            )}
          </div>
        </div>
        <div className="mb-4 flex flex-col items-center gap-4 px-6 lg:flex-row lg:gap-0">
          <p className="flex items-center gap-1 text-base font-semibold text-black">
            {t('pages.create_library.images')}
            <span className="text-sm font-normal text-grey-06">
              {nmOfImage}
            </span>
          </p>
          <div className="ml-auto flex items-center">
            <Button
              className="flex items-center"
              variant="ghost"
              size="sm"
              onClick={() =>
                sort[0].desc
                  ? setSort([{ id: 'createdAt', desc: false }])
                  : setSort([{ id: 'createdAt', desc: true }])
              }
            >
              <div className="pr-2">{t('pages.create_courses.latest')}</div>
              {sort[0].desc ? (
                <ChevronUp className="w-5" />
              ) : (
                <ChevronDown className="w-5" />
              )}
            </Button>
          </div>
          <Button
            size="sm"
            className="flex items-center gap-2"
            onClick={() => {
              setIsOpenAddModal(true);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              data-lucide="image-plus"
              aria-hidden="true"
            >
              <path d="M16 5h6"></path>
              <path d="M19 2v6"></path>
              <path d="M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5"></path>
              <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
              <circle cx="9" cy="9" r="2"></circle>
            </svg>
            {t('pages.create_library.add_image')}
          </Button>
        </div>
        <div className="flex max-h-[40vh] w-full flex-wrap justify-center overflow-y-scroll px-6">
          {loadImages && (
            <div className="mx-auto flex justify-center py-20 px-10">
              <TEOLoader
                loaderSrc="/images/TEOloader.gif"
                className="w-[100px]"
              />
            </div>
          )}
          <PaginationPlusOne
            className={`mt-3 grid w-full grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-3 ${
              loadImages === true && ' hidden '
            }`}
            fetch={useGet.bind(null, `/imagelibraries`, {
              organisationId: `${authUser.activeOrganisationId}${
                authUser?.useTeoLib ? ',OR,organisationId=null' : ''
              }`,
              onSuccess: (result) => {
                setLoadImages(false);
                const contentRange = result?.headers?.['content-range']
                  ?.split(' ')?.[1]
                  ?.split('/');
                const maxCount = contentRange
                  ? Math.ceil(contentRange?.[1])
                  : 1;
                setNmOfImage(maxCount);
              },
            })}
            defaultSort={sort}
            empty={{
              template: 2,
              loadContent: loadImages,
              text: t('pages.create_library.library_empty'),
            }}
            page={0}
            pageSize={12}
            filter={filterJoined}
            render={(img) => {
              const arrTag = img?.tags?.split(';;');
              const imgTags = arrTag
                ?.filter((x) => x?.startsWith('tag:'))
                ?.map((el) => el?.split('tag:')[1]);
              return (
                <div key={img?.id} className="relative">
                  <div
                    className="group max-w-[235px] cursor-pointer rounded-lg"
                    onClick={async () => {
                      lessonPage
                        ? onSelectImage && onSelectImage(img?.imageUrl)
                        : onSelectImage && onSelectImage(img?.imageUrl);
                      setIsOpenLibraryModal(!isOpenLibraryModal);

                      // await axios.delete(`${config.backend}/imagelibrary/${img?.id}`);
                    }}
                  >
                    <img
                      src={img?.imageUrl}
                      className="h-[156px] w-full rounded-lg object-cover object-center"
                    />
                    <div className="absolute right-2 top-2 hidden items-center justify-center gap-1 rounded-md bg-primary-04 px-2 py-1 group-hover:flex">
                      <Check className="h4 w-4" />
                      <p className="text-xs font-medium">
                        {t('pages.create_library.use_img')}
                      </p>
                    </div>
                    <div className="absolute left-2 bottom-2 hidden flex-wrap items-center justify-start gap-2 group-hover:flex">
                      {imgTags?.map((tag, i) => (
                        <div
                          key={i}
                          className="rounded-[4px] border border-white bg-[#777777a1]  px-2 py-[1px] text-xs text-white"
                        >
                          {tag}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};
